import React from "react";
import { useSite } from "@/lib/SiteContext";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import FourSeasons from "@/components/site/FourSeasons";
import Manifesto from "@/components/site/Manifesto";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import ServiceArea from "@/components/site/ServiceArea";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
    const { site, gallery, loading } = useSite();

    if (loading || !site) {
        return (
            <div className="min-h-screen bg-ink-900 flex items-center justify-center">
                <div className="font-mono-label text-white/50">Loading…</div>
            </div>
        );
    }

    return (
        <div className="bg-ink-900 text-white overflow-hidden">
            <Nav site={site} />
            <Hero site={site} />
            <Marquee site={site} />
            <Services site={site} />
            <FourSeasons site={site} />
            <Manifesto site={site} />
            <Gallery items={gallery} />
            <Testimonials site={site} />
            <ServiceArea site={site} />
            <Contact site={site} />
            <Footer site={site} />
        </div>
    );
}
